import React from "react";
import { getStyle } from "../../../styles/styles";
import { getDefaultPagingNumberOfItems } from "../../../helpers/PackageJsonHelper";
import { deleteBNFeeStructure, DeleteBNFeeStructureDetails, getBNFeeStructure, getBNFeeStructureByID, GetBNFeeStructureDetailById, getBNFeeStructureDetails, getFeeStructureByID } from "../../../networking/NetworkingFeeStructure";
import BNFeeStructureForm from "./BNFeeStructureForm";
import NewDynamicTable from "../../shared/NewDynamicTable";
import { InfoCircleOutlined } from '@ant-design/icons';
import { Breadcrumb } from "antd";
import BNFeeStructureDetailForm from "./BNFeeStructureDetailForm";
import AlertBox from "../../shared/AlertBox";

var style = getStyle()

const itemsPerPage = getDefaultPagingNumberOfItems()

export default class BNFeeStructureScreen extends React.Component {
    state = {
        feeStructureList: [],
        newSearch: false,
        objFeeStructure: [],
        readyToDelete: {},
        objFeeStructure: [],
        selectedFeeStructure: {},
        selectedFeeStructureDetail: {},
        feeStructureDetailList: [],
        step:1,
        clearFee: false,
        clearForm: false,
        clearDetail: false,
        totalPagesStructure:0,
        pagesStructure:1,
        totalPagesDetails:0,
        pagesDetails:1,
        //Alerts
        showDeleteAlert: false,
        showSuccessDeleteAlert: false,
        alertTitle:'',
        alertMessage:''
    }

    componentDidMount() {
        getBNFeeStructure().then(
            (json) => {
                if(json !== undefined && json.feeStructures !== undefined){
                    var feestructure = this.transformFeeStructureList(json.feeStructures);
                    var helper = this.changeDefaultLabels(feestructure);
                    var totalCount = json.feeStructures.length;
                    var pages = Math.ceil(totalCount/itemsPerPage);
                    this.setState({feeStructureList: helper, totalPagesStructure: pages, newSearch: false})
                }
            }
        )
    }
    
    changePageStructure = (value) =>{
        this.setState({pagesStructure: value, newSearch: false});
    }
    
    getAllFee = async () =>{
        var json = await getBNFeeStructure();
        var allFee = this.transformFeeStructureList(json.feeStructures);
        return allFee;
    }

    changePageDetails = (value) =>{
        this.setState({pagesDetails: value, newSearch: false});
    }

    getAllDetails = async () =>{
        var json = await getBNFeeStructureDetails(this.state.selectedFeeStructure.FeeStructureID);
        var allDetails = this.transformSpotList(json.feeStructureDetails);
        return allDetails;
    }

    changeDefaultLabels(collection){
        var helper = collection;
        for(var i=0; i<collection.length;i++){
            if(collection[i]['Default']){
                collection[i]['Default'] = 'True';
            }else{
                collection[i]['Default'] = 'False';
            }
        }
        return helper;
    }

    transformFeeStructureList(list){
        var helper = [];
        for(var i = 0; i<list.length; i++){
            helper.push({
                'FeeStructureID': list[i]['FeeStructureID'],
                'Description': list[i]['Description'],
                'Default': list[i]['Default']
            });
        }
        return helper;
    }

    onClickStepTab(value){
        this.setState({step: value});
    }

    handleRowClick(obj){
        getBNFeeStructureByID(obj['FeeStructureID']).then(
            (value)=>{
                this.setState({selectedFeeStructure: value.feeStructure[0],selectedFeeStructureDetail: value.feeStructure[0]});
            }
        );
    }

    handleRowTableClick(obj){
        debugger
        GetBNFeeStructureDetailById(obj['FeeStructureDetailId']).then(
            (value)=>{
                debugger
                if(value !== undefined && value.feeStructureDetail !== undefined){
                    this.setState({selectedFeeStructureDetail: value.feeStructureDetail[0]});
                }
            }
        );
    }

    handleDeleteClick(obj){
        debugger;
        this.setState({showDeleteAlert: true, readyToDelete: obj});
    }
    
    handleDeleteDetailClick(obj){
        this.setState({showDeleteAlert: true, readyToDelete: obj});
    }

    closeDeleteAlert(){
        debugger;
        this.setState({showDeleteAlert: false, readyToDelete: {}});
    }

    openDeleteAlert(){
        this.setState({showDeleteAlert: true});
    }

    okSuccessAlert(){
        this.setState({showSuccessDeleteAlert: false});
    }

    yesDeleteAlert(){
        deleteBNFeeStructure(this.state.readyToDelete.FeeStructureID).then(
            (value)=>{
                if(value.httpStatusCode!==200){
                    this.setState({showDeleteAlert: false, showSuccessDeleteAlert: true,alertTitle:"Error", alertMessage:'First, must to delete Fee Structure Detail'})
                }else{
                    this.setState({showDeleteAlert: false, showSuccessDeleteAlert: true,alertTitle:"Success", alertMessage:"Fee Structure successfully removed.",clearFee: true},()=>this.updateTable());
                }
            }
        );
    }

    yesDeleteDetailAlert(){
        DeleteBNFeeStructureDetails(this.state.readyToDelete.FeeStructureDetailId).then(
            (value)=>{
                if(value.httpStatusCode!==200){
                    this.setState({showDeleteAlert: false, showSuccessDeleteAlert: true,alertTitle:"Error", alertMessage:value.Message, clearForm: true});
                }else{
                    this.setState({showDeleteAlert: false, showSuccessDeleteAlert: true,alertTitle:"Success", alertMessage:"Fee Structure successfully removed.", clearForm: true},()=>this.updateFeeStructureDetailsTable(this.state.readyToDelete['FeeStructureID']));
                }                
            }
        );
    }
    
    handleSelection(obj){        
        this.setState({objFeeStructure: obj});
    }

    updateTable(){
        getBNFeeStructure().then(
            (value) => {
                var feestructure = this.transformFeeStructureList(value.feeStructures);           
                var helper = this.changeDefaultLabels(feestructure);
                this.setState({feeStructureList: helper});                
            }
        )
    }

    updateFeeStructureDetailsTable(value){
        this.updateFeeStructureDetailList(value);
    }

    outClearForm(value){
        this.setState({clearForm: value});
    }
    isClearForm = () =>{
        this.setState({selectedFeeStructure:[]});
    }
    isClearDetail = (value) =>{
        this.setState({clearDetail: value, selectedFeeStructureDetail:[],totalPagesDetails:0,pagesDetails:1,});
    }
    outClearFee(value){
        this.setState({clearFee: value});
    }

    updateFeeStructureDetailList(value){
        if(value===undefined || value===''){
            this.setState({feeStructureDetailList: []});            
        }else{
            getBNFeeStructureDetails(value).then(
                (json) =>{
                    this.setState({feeStructureID: value});
                    if(json.feeStructureDetails!== undefined){
                    var feestructuredetails = this.transformSpotList(json.feeStructureDetails);
                    var totalCount = feestructuredetails.length;
                    var pages = Math.ceil(totalCount/itemsPerPage);
                    this.setState({feeStructureDetailList: feestructuredetails, totalPagesDetails: pages, newSearch: false})
                    }else{
                        this.setState({feeStructureDetailList: []});
                    }                    
                }
            )
        }
    }

    transformSpotList(list){
        var helper = [];
        for(var i = 0; i<list.length; i++){
            helper.push(
                {                    
                    'FeeStructureDetailId': list[i]['FeeStructureDetailId'],
                    'FeeStructureID': list[i]['FeeStructureID'],
                    'Buy / Sell': list[i]['BuySell'],
                    'Settlement Ccy': list[i]['CurrencyID'],
                    //'Delivery Method': list[i]['DeliveryMethod'],
                    'Percent / Flat': list[i]['PercentFlat'],
                    'Percentage': list[i]['Percentage'],
                    'Lower Tier': list[i]['LowerTier'],
                    'Upper Tier': list[i]['UpperTier'],
                    'Minimum Fee': list[i]['Minimum'],
                    'Maximum Fee': list[i]['Maximum'],
                }
            );
        }
        return helper;
    }

    handleDetailClick = (obj) => {
        getBNFeeStructureByID(obj['FeeStructureID']).then(
            (value)=>{
                if(value !== undefined && value.feeStructure !== undefined){
                    this.setState({selectedFeeStructure: value.feeStructure[0],selectedFeeStructureDetail: value.feeStructure[0]}, ()=>{this.setState({step: 2});});
                }
            }
        )
    }

    render(){
        var stepScreen = [];
        let breadcrumb = [];

        var classNameStep1, classNameStep2 = "";

        switch(this.state.step){
            case 1:
                classNameStep1 = "uk-active";
                breadcrumb.push(
                    <Breadcrumb.Item className="breadcrumb-item-bold">Fee Structures</Breadcrumb.Item>
                );
                stepScreen.push(
                    <BNFeeStructureForm  key="bn-fee-structure-form" isClearForm = {this.isClearForm} updateCategoryTable={this.updateTable.bind(this)} selectedFeeStructure={this.state.selectedFeeStructure}  clearForm={this.state.clearFee} outClearForm={this.outClearFee.bind(this)}/>,
                    <NewDynamicTable key="bn-fee-structure-screen"
                                    data={this.state.feeStructureList} 
                                    enableClick={true} 
                                    hiddenHeaders={['FeeStructureID']}
                                    clickFunction={this.handleRowClick.bind(this)} 
                                    dynamicActions  = {[{name: 'Details', function: this.handleDetailClick, isIcon: true, icon: <InfoCircleOutlined />}]}
                                    newSearch={this.state.newSearch} 
                                    useDeleteButton={true} 
                                    deleteFunction={this.handleDeleteClick.bind(this)}
                                    usePaginator={true}
                                    changePage={this.changePageStructure}
                                    numberOfPages={this.state.totalPagesStructure}
                                    pageNumber = {this.state.pagesStructure}
                                    numberPerPage = {getDefaultPagingNumberOfItems()}
                                    enableSortByHeader={true}
                                    useFilter={true} 
                                    useIcons={true}
                                    filterFunction={this.getAllFee}/>,
                    <AlertBox id="delete-bn-fee-structure" open={this.state.showDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title="Are you sure you want to delete this Fee Structure?" message="This action can not be undone." type="Yes/No" yesClick={this.yesDeleteAlert.bind(this)} noClick={this.closeDeleteAlert.bind(this)}/>,
                    <AlertBox open={this.state.showSuccessDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.okSuccessAlert.bind(this)}/>
                )
                break;
            case 2:
                classNameStep2 = "uk-active";
                breadcrumb.push(
                    <Breadcrumb.Item className="breadcrumb-item" onClick={() => {
                        this.onClickStepTab(1);
                    }}>Fee Structures</Breadcrumb.Item>
                );
                breadcrumb.push(
                    <Breadcrumb.Item className="breadcrumb-item-bold">Fee Structure Detail - {this.state.selectedFeeStructureDetail.Description}</Breadcrumb.Item>
                );
                stepScreen.push(
                    <BNFeeStructureDetailForm key="bn-fee-structure-detail-form" feeSelectValue={this.updateFeeStructureDetailList.bind(this)} updateFeeStructureDetailsTable={this.updateFeeStructureDetailsTable.bind(this)} selectedFeeStructureDetail={this.state.selectedFeeStructureDetail} isClearDetail = {this.isClearDetail} clearForm={this.state.clearForm} outClearForm={this.outClearForm.bind(this)}/>,
                    <NewDynamicTable hiddenHeaders={['FeeStructureDetailId','FeeStructureID']} 
                                    key="bn-fee-structure-detail-screen" 
                                    data={this.state.feeStructureDetailList} 
                                    enableClick={true} 
                                    clickFunction={this.handleRowTableClick.bind(this)} 
                                    newSearch={this.state.newSearch} 
                                    useDeleteButton={true} 
                                    deleteFunction={this.handleDeleteDetailClick.bind(this)}
                                    usePaginator={true}
                                    changePage={this.changePageDetails}
                                    numberOfPages={this.state.totalPagesDetails}
                                    pageNumber = {this.state.pagesDetails}
                                    numberPerPage = {getDefaultPagingNumberOfItems()}
                                    enableSortByHeader={true}
                                    useFilter={true}
                                    useIcons={true}
                                    filterFunction={this.getAllDetails}/>,
                    <AlertBox id="delete-bn-fee-structure" open={this.state.showDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title="Are you sure you want to delete this Fee Structure?" message="This action can not be undone." type="Yes/No" yesClick={this.yesDeleteDetailAlert.bind(this)} noClick={this.closeDeleteAlert.bind(this)}/>,
                    <AlertBox open={this.state.showSuccessDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.okSuccessAlert.bind(this)}/>
                )
                break;
            default:
                classNameStep1 = "uk-active";
                breadcrumb.push(
                    <Breadcrumb.Item className="breadcrumb-item-bold">Fee Structures</Breadcrumb.Item>
                );
                stepScreen.push(
                    <BNFeeStructureForm  key="bn-fee-structure-form" isClearForm = {this.isClearForm} updateCategoryTable={this.updateTable.bind(this)} selectedFeeStructure={this.state.selectedFeeStructure}  clearForm={this.state.clearFee} outClearForm={this.outClearFee.bind(this)}/>,
                    <NewDynamicTable key="bn-fee-structure-screen"
                                    data={this.state.feeStructureList} 
                                    enableClick={true} 
                                    hiddenHeaders={['FeeStructureID']}
                                    clickFunction={this.handleRowClick.bind(this)} 
                                    dynamicActions  = {[{name: 'Details', function: this.handleDetailClick, isIcon: true, icon: <InfoCircleOutlined />}]}
                                    newSearch={this.state.newSearch} 
                                    useDeleteButton={true} 
                                    deleteFunction={this.handleDeleteClick.bind(this)}
                                    usePaginator={true}
                                    changePage={this.changePageStructure}
                                    numberOfPages={this.state.totalPagesStructure}
                                    pageNumber = {this.state.pagesStructure}
                                    numberPerPage = {getDefaultPagingNumberOfItems()}
                                    enableSortByHeader={true}
                                    useFilter={true} 
                                    useIcons={true}
                                    filterFunction={this.getAllFee}/>,
                    <AlertBox id="delete-bn-fee-structure" open={this.state.showDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title="Are you sure you want to delete this Fee Structure?" message="This action can not be undone." type="Yes/No" yesClick={this.yesDeleteAlert.bind(this)} noClick={this.closeDeleteAlert.bind(this)}/>,
                    <AlertBox open={this.state.showSuccessDeleteAlert} onClose={this.closeDeleteAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.okSuccessAlert.bind(this)}/>
                )
                break;
        }
        return(
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        {breadcrumb}
                    </Breadcrumb>
                </div>
                {stepScreen}
            </div>
        );
    }
}